import React from 'react';

const funnelIcon =
    <img src="/images/admin/global/status/funnel.svg" width="16px" alt="" />
export default funnelIcon;